import { render, staticRenderFns } from "./emailsEditar.vue?vue&type=template&id=256b4b18&scoped=true&"
import script from "./emailsEditar.vue?vue&type=script&lang=js&"
export * from "./emailsEditar.vue?vue&type=script&lang=js&"
import style0 from "./emailsEditar.vue?vue&type=style&index=0&id=256b4b18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256b4b18",
  null
  
)

export default component.exports